import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/2c7f9303/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArtDirection = makeShortcode("ArtDirection");
const Caption = makeShortcode("Caption");
const Aside = makeShortcode("Aside");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`The elements constructing each chart are designed to work in harmony. Each piece plays an important role in data communication.`}</p>
    </PageDescription>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` This guidance is a work in progress. To see our roadmap, make feature requests, or contribute, please go to carbon-charts `}<a parentName="p" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts"
        }}>{`GitHub repository`}</a>{`.`}</p>
    </InlineNotification>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Rectangular charts</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Circular charts</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "rectangular-charts"
    }}>{`Rectangular charts`}</h2>
    <p>{`Most data visualizations are rectangular charts, with two dimensions represented on a vertical and a horizontal axis. Rectangular charts are typically constructed with a set of common elements including a legend, axis titles, and navigation tools like a zoom bar and tooltip.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={8} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "684px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAADFklEQVQ4y6VUyW4bRxSc//+F+JRDYBhIzrnEB/tgWFAAURIpLiOSsy9kz9rLbN2VN0NSoh3ZCJAGHrpn6Xr96lW1ZYyB0RrjrGnW57X54dq8/DvO47jGsPA/xwX0MqyhVmAfvqAvBTbzBZ7nS/j2Hvuljd38CcF5vbqfw10/w109w1tvsbp7BC8rQgQ6ViP74wZ9LgiQNyj+vEOTSyxv1/BoQ7x1ET67WCwcxDsfwWaP3WINf7NDaDtgYYpg50IJOQEOskH91cYgGlh9KZG9/4yjXeLm9xD8yCDTHFVa4rc7DhblqOMjOL0bo06zb0v+jgILI6EnMmAoA2SPcO+B8xqm7yGEgFIKYRCgStj0HaIFeAtDAdHRvhZqHUI3HaxLhqHtwEOGgXHMbv6Gbdvw/QCOQ2XHMe5n9wiWW7SHCiLOIOMcaoykmObDr5/QE5fWKAOtuqlbfdehIV4yxlCWJaqqmk44BqN3ouZo6bQjd2M0UqFRYtr3UnJfCKS//IUuqyGPBWongSrqH8qkHV55I+lB5N/yaI11q6dgAnMeVkDZQFUc2pwE/CL4SW8GtaJKen1aMwPmagjWoScqTD+cdJiRDmWSw70nwLpFK9QLoNYXBxGg0WjO1Q2Noa6PSTTajCN59/HE4XTCRw+q5Ih2Hp20BC+KsyTMWRivRe0OEpu9j0NExUgNNZzlc7HeUMnJKSotcPRidMTpcV+DH4ivkk5BkR4G+KmElynMgwpPqyPCVCOqWiwj0qocrnR4HmPHvNUWUD2qTKIQGgEbsPEHzBYtbj9tiOMn+A9LVG4CUBN7omk3WyD30pN9qXTrYu6Rt8QNSLgd3EONiLKKfpg4IlFhtvSwJ29v5htsyYb24xKJQzolq9Ysh3xwoWV7dsrlGiIAtg2Qkn/LiOTDSpQxm6hocw6VV0i9BHl0IO/X03z0IsjyVWaWuQLUBMizkjIWU5MMCb6r5fQ8ZmdOSBIpIItqEmTHFTg9d1Td2LepKdeX5M/GQF2MHJ9c0b95KVz2W9cP5krM38e/Nr/x/T/d2G8l+1lF/wCP0gSdQ7RjuQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color in UI",
              "title": "Color in UI",
              "src": "/static/fc65dda5d5380712746f8ccdbf7b5aa5/40ede/chart-anatomy-1sm.png",
              "srcSet": ["/static/fc65dda5d5380712746f8ccdbf7b5aa5/1a057/chart-anatomy-1sm.png 288w", "/static/fc65dda5d5380712746f8ccdbf7b5aa5/8418d/chart-anatomy-1sm.png 576w", "/static/fc65dda5d5380712746f8ccdbf7b5aa5/40ede/chart-anatomy-1sm.png 684w"],
              "sizes": "(max-width: 684px) 100vw, 684px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABvklEQVQoz42Ti46jMAxF+/8/uDOVpo+hpTxDgSTkAZx1YGYrrTTajRRMbONc32sO/Oda13XbfNsfcg4pNP26098arscT+eVGdsp4nD/JT59iM7q6fX3EXsx2I6buiL1lHifcqdz8h3SZe7tRvbVUp4Lq0XK8KPq8ROUVph8JIbAsC6tsloQSonGEwbIYzxoisR33gvwFP924PC25IKyqirZtUUpxu98or3dWiQc1Ep+G2BlCp4kJ4aX6KijLZw2znpi6AWcmoiCarJwnh3MO7z1Wzs6JzwTsKH7rtrwosXnyuGv91bI83PFBd3lgCrW39ZMwM7Slw+qIn0D3kUkvBO1fLW8F33PGomWslCD0LHEhuhkfZoJwNoSFeoiUdSBrLKVwO/WDtOowaiAI2iRMEuyQpJ6Vpi8aTDPQdZ6mnylUpGgCtQqMemZ4RtFjpXNw/sjJ3j/ILgX38x3dDnhRed1V3kVJfIyloqieGz/OWKZBM4uafTlgn3rjapRx8YlnyWnbnkaJMHF5zeH3yyaOEO9HA9JqTERru43JIHOo1RPmdfOlWMoJcunq/JazLvvQ/0H40/Tvw/yPv2gvsNnfNKtXQ6ez2c0AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color in UI",
              "title": "Color in UI",
              "src": "/static/f1b29059362407bfab4bd6fa85312ea0/c801a/chart-anatomy-1.png",
              "srcSet": ["/static/f1b29059362407bfab4bd6fa85312ea0/1a057/chart-anatomy-1.png 288w", "/static/f1b29059362407bfab4bd6fa85312ea0/8418d/chart-anatomy-1.png 576w", "/static/f1b29059362407bfab4bd6fa85312ea0/c801a/chart-anatomy-1.png 1152w", "/static/f1b29059362407bfab4bd6fa85312ea0/a1f35/chart-anatomy-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABvklEQVQoz42Ti46jMAxF+/8/uDOVpo+hpTxDgSTkAZx1YGYrrTTajRRMbONc32sO/Oda13XbfNsfcg4pNP26098arscT+eVGdsp4nD/JT59iM7q6fX3EXsx2I6buiL1lHifcqdz8h3SZe7tRvbVUp4Lq0XK8KPq8ROUVph8JIbAsC6tsloQSonGEwbIYzxoisR33gvwFP924PC25IKyqirZtUUpxu98or3dWiQc1Ep+G2BlCp4kJ4aX6KijLZw2znpi6AWcmoiCarJwnh3MO7z1Wzs6JzwTsKH7rtrwosXnyuGv91bI83PFBd3lgCrW39ZMwM7Slw+qIn0D3kUkvBO1fLW8F33PGomWslCD0LHEhuhkfZoJwNoSFeoiUdSBrLKVwO/WDtOowaiAI2iRMEuyQpJ6Vpi8aTDPQdZ6mnylUpGgCtQqMemZ4RtFjpXNw/sjJ3j/ILgX38x3dDnhRed1V3kVJfIyloqieGz/OWKZBM4uafTlgn3rjapRx8YlnyWnbnkaJMHF5zeH3yyaOEO9HA9JqTERru43JIHOo1RPmdfOlWMoJcunq/JazLvvQ/0H40/Tvw/yPv2gvsNnfNKtXQ6ez2c0AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color in UI",
              "title": "Color in UI",
              "src": "/static/f1b29059362407bfab4bd6fa85312ea0/c801a/chart-anatomy-1.png",
              "srcSet": ["/static/f1b29059362407bfab4bd6fa85312ea0/1a057/chart-anatomy-1.png 288w", "/static/f1b29059362407bfab4bd6fa85312ea0/8418d/chart-anatomy-1.png 576w", "/static/f1b29059362407bfab4bd6fa85312ea0/c801a/chart-anatomy-1.png 1152w", "/static/f1b29059362407bfab4bd6fa85312ea0/a1f35/chart-anatomy-1.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
        <Caption mdxType="Caption"></Caption>
      </Column>
      <Column colLg={2} colMd={2} colSm={2} offsetLg={1} mdxType="Column">
  <Aside mdxType="Aside">
    1. Chart title<br />
    2. Legends<br />
    3. Axes<br />
    4. Ticks<br />
    5. Axis title<br />
    6. Toolbar<br />
    7. Zoom bar<br />
    8. Graph frame<br />
    9. Tooltip<br />
  </Aside>
      </Column>
    </Row>
    <h4 {...{
      "id": "chart-title"
    }}>{`Chart title`}</h4>
    <p>{`The title of a visualization should be concise and descriptive and should reflect the insight the data reveals.`}</p>
    <h4 {...{
      "id": "legend"
    }}>{`Legend`}</h4>
    <p>{`Many charts will use different visual properties such as colors, textures, and shapes to represent different categories or dimensions of data. A legend tells you what these associations mean and helps you to determine the chart’s meaning. `}<a parentName="p" {...{
        "href": "../data-visualization/legends"
      }}>{`Read more on legend usage.`}</a></p>
    <h4 {...{
      "id": "axes"
    }}>{`Axes`}</h4>
    <p>{`The X-axis is horizontal and the Y-axis is vertical. Axes should be accessible against their background with a 3:1 contrast ratio. `}<a parentName="p" {...{
        "href": "../data-visualization/axis-and-labels"
      }}>{`Read more on axes usage.`}</a></p>
    <h4 {...{
      "id": "tooltip"
    }}>{`Tooltip`}</h4>
    <p>{`A tooltip is a message that appears when a cursor is positioned over an element, such as a data point, icon button, or truncated text. By default, tooltips show on hover to reveal more detailed information or context for specific chart elements. A tooltip should repeat the corresponding values of the data point on both axes and any other relevant details.`}</p>
    <h4 {...{
      "id": "graph-frame"
    }}>{`Graph frame`}</h4>
    <p>{`The graph frame is the area where data will be visualized with graphics or numbers. Gridlines help a viewer estimate the values of a data point but are not required. Use gridlines sparingly, as too much visual noise makes the graph frame busy and negatively impacts the user’s ability to interpret the data.`}</p>
    <h2 {...{
      "id": "circular-charts"
    }}>{`Circular charts`}</h2>
    <p>{`Circular charts are primarily pie and donut charts. Other circular layout charts include radar and solar charts.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={8} colSm={4} mdxType="Column">
        <ArtDirection mdxType="ArtDirection">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "684px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAADtklEQVQ4y32UTWwbVRDH98i93OGGxIUblwIHDiBEldwqhRtIVcSpQohTKwqH0iChggKlAVRE2oZCg5BQFUBJP0OgadXQREWJ49qJ6yT+2rW99treXb99+2N2/RGHlj5p9N7uvv3Pf2b+M0YYhoRaE+9iWs6699w76863aD1qHzwbdFfI41fvx//a4PdoGYHjYv34F2HDx9rJsfr3Cpm1FDupDJlEigdr62ST6f91pJTayzBoeFR+vQu+orhhsb60xnZqk+37GQobWVZXM6TXM6iWj/LaeK6HZdcI5H4UVhAEHcAuYyOotyhNzoPXJHU1YHvZoWVXqBbKtMsVZhIeyS0HzyrQKJlspLc489tlXMvup+mROey80eJSPLWDeI+W9n2K8nMxpXEr0TsdZzz0ZY/uKb0HwugnOHpyFXa2iDbrwqbGkXMX2Pf2KMbBNzn2gsMnL2lmPvSppVy520KXxQp1lNwvTd5AWc4uYMym6QuYw8b9Bzzz7nsYw8O88tEJTv40w+LZJtOHFceeCxh/XVFaFtBWi8BsErpt/J2yRKYGGQpoqw22x/NH38cYGWFucUmYiCdfrN2Ss+R5zuPE/oCvDir8vHwUEr30xCH3y99N8fnZ68JsiO+v3IjTpeseyhawmjirB1FeWJn2OPpswO1Jl6aVxxel7Fa5JlX+9hp+xYmZDI2NsW/0kAB4Eo6DuZzCS+Ypr6TJ3UnQNkUyZZ/xA4pzoyIjUUIQFadfFInbTRcIAx0X5cXj4wx9+rWEEuDnqiR+uEL+0i3S09e5d/536mvbULK5eMhl4oAwL4oDKYY5tYASUntbT8T62gWTl6csCU/yU3YpXL5L8pd5NmduUvszIe+kCJbii7eSnHrDhKoXF8VNFdAi/E5RpPlVLDHFkdkKT5zMk8s1QdrSE4B23qaZKeFmK2hh10g0OHt4nT++yUKjHUenhUyEY9BtmzgLEn4y48SAIz9bMSDScn4yR3b2Fs7NfyhcW2Lr6jKpS0vYt5ME25VYf4UvZyW/9Q5gT9hBsx2DnF6sYYzlGb5ocm+zQW3Hxt60mF8tMv6ByalX69yZkmKYZbGGdI2KWXZabwAwFB2GFUl0ucbEgsmTnxcwPs7x1ESRp0+XMIT5/uNVFj5TUmmRikgqrLq77ReyG3IM6MkEcXzsvIRbrVKyfM4s1Xlnrhrbd3LOWa3ooqhAwAQQx+uwe2g49CZG91E/ZtjKEO9df2jiGF3ovgfC3emsxZRULgg7Fp31wOzrz4E+esi/1MrGGB9MdYAAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color in UI",
              "title": "Color in UI",
              "src": "/static/c80dee96804a93b3acf8caf3d9a631f3/40ede/chart-anatomy-2sm.png",
              "srcSet": ["/static/c80dee96804a93b3acf8caf3d9a631f3/1a057/chart-anatomy-2sm.png 288w", "/static/c80dee96804a93b3acf8caf3d9a631f3/8418d/chart-anatomy-2sm.png 576w", "/static/c80dee96804a93b3acf8caf3d9a631f3/40ede/chart-anatomy-2sm.png 684w"],
              "sizes": "(max-width: 684px) 100vw, 684px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABlklEQVQoz42ST08TQRjG+Uac+QBy8EOQED2acLIng3dj4kXOJEKwGGjCiSierIloEC6EYGttdwnprt2y67J/ZtiZ+TlbaFMRKHN6M++8z/s88zxTjB1jDPc54++uz0wNL4eN9PAEFaV4bpeTZhu31cFpuShZIKVCKYXW+p+Z8fpmwNACNhP6p7+5iDI8P0fnMf6fLr0gvAS5i+GoMdZUmbToirV6nUdLy1SfJRy8UyAE5lxQWBV5y7uZ4fX/0OX+AhZXqswsPmfr01caOzlv5gs+vhAgS8YFKhGTJQsvLBFptB2mK0/JezFktpGFSD9heU7T+RKXGu5nSuYG9q1h89sRC2vvoXdOo1anVduFwKdWSTl4m9ihlKzpT5Y83LfvCh6un0GcIo4d4r0f0A/YefUT93NkVUhkN5os2WiDLkshebwV8GQ7pOvE7H9vs/6yw+GqgwnOULFAlGruYsiV07qs8wtiL6LyIWC2GvBgs8/rjQz5y7qViVEgbo3NEHDkdElT60HilP1TVeiB/4MMqMvFRv8f7L+SnUcXyUcKrwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color in UI",
              "title": "Color in UI",
              "src": "/static/6718769f7bff9e238bb8dc69fbce0535/c801a/chart-anatomy-2.png",
              "srcSet": ["/static/6718769f7bff9e238bb8dc69fbce0535/1a057/chart-anatomy-2.png 288w", "/static/6718769f7bff9e238bb8dc69fbce0535/8418d/chart-anatomy-2.png 576w", "/static/6718769f7bff9e238bb8dc69fbce0535/c801a/chart-anatomy-2.png 1152w", "/static/6718769f7bff9e238bb8dc69fbce0535/a1f35/chart-anatomy-2.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABlklEQVQoz42ST08TQRjG+Uac+QBy8EOQED2acLIng3dj4kXOJEKwGGjCiSierIloEC6EYGttdwnprt2y67J/ZtiZ+TlbaFMRKHN6M++8z/s88zxTjB1jDPc54++uz0wNL4eN9PAEFaV4bpeTZhu31cFpuShZIKVCKYXW+p+Z8fpmwNACNhP6p7+5iDI8P0fnMf6fLr0gvAS5i+GoMdZUmbToirV6nUdLy1SfJRy8UyAE5lxQWBV5y7uZ4fX/0OX+AhZXqswsPmfr01caOzlv5gs+vhAgS8YFKhGTJQsvLBFptB2mK0/JezFktpGFSD9heU7T+RKXGu5nSuYG9q1h89sRC2vvoXdOo1anVduFwKdWSTl4m9ihlKzpT5Y83LfvCh6un0GcIo4d4r0f0A/YefUT93NkVUhkN5os2WiDLkshebwV8GQ7pOvE7H9vs/6yw+GqgwnOULFAlGruYsiV07qs8wtiL6LyIWC2GvBgs8/rjQz5y7qViVEgbo3NEHDkdElT60HilP1TVeiB/4MMqMvFRv8f7L+SnUcXyUcKrwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Color in UI",
              "title": "Color in UI",
              "src": "/static/6718769f7bff9e238bb8dc69fbce0535/c801a/chart-anatomy-2.png",
              "srcSet": ["/static/6718769f7bff9e238bb8dc69fbce0535/1a057/chart-anatomy-2.png 288w", "/static/6718769f7bff9e238bb8dc69fbce0535/8418d/chart-anatomy-2.png 576w", "/static/6718769f7bff9e238bb8dc69fbce0535/c801a/chart-anatomy-2.png 1152w", "/static/6718769f7bff9e238bb8dc69fbce0535/a1f35/chart-anatomy-2.png 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArtDirection>
        <Caption mdxType="Caption"></Caption>
      </Column>
      <Column colLg={2} colMd={2} colSm={2} offsetLg={1} mdxType="Column">
  <Aside mdxType="Aside">
    1. Chart title<br />
    2. Legends<br />
    3. Label<br />
    4. Graph frame<br />
    5. Big number<br />
    6. Tooltip<br />
  </Aside>
      </Column>
    </Row>
    <h4 {...{
      "id": "label"
    }}>{`Label`}</h4>
    <p>{`A label offers the percentage value of the whole for an individual category.`}</p>
    <h4 {...{
      "id": "big-number-or-kpi"
    }}>{`Big number or KPI`}</h4>
    <p>{`A key performance indicator (KPI) consists of a number with a single word description. Examples include “15,250 browsers”, “\$1.3M revenue”, or “Total 450”. A big number inside the donut chart may be used to display a total sum or the individual count of a slice upon interaction. This element can also be used independently on a dashboard (though please note this component is still a WIP and not available outside the donut chart).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      